<div
    class="old-subheader-bar"
    [ngClass]="styleClass">
    <div
        *ngIf="showHazardCreatedInCr13Warning"
        class="old-subheader-bar__hazard-created-warning">
        <div class="old-subheader-bar__hazard-created-warning__content">
            <i class="ci ci-alert"></i>
            <p>{{ 'PAGE.ANALYSIS.CRITERIA_BAR.HAZARD_CREATED_WARNING.TXT' | translate }}</p>
        </div>
    </div>
    <div class="old-subheader-bar-content-left">
        <p>{{ titleText }}</p>
        <ng-content select="[subheaderContentLeft]"></ng-content>
    </div>
    <div class="old-subheader-bar-content-center">
        <ng-content select="[subheaderContentCenter]"></ng-content>
    </div>
    <div class="old-subheader-bar-content-right">
        <ng-content select="[subheaderContentRight]"></ng-content>
    </div>
</div>
